import { Button, Stack, Typography } from '@mui/material';
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { useProviderTransactionsTable } from '@Modal/hooks/providerTransactions/useProviderTransactionsTable';
import { useTransactionExportsTable } from '@Modal/hooks/transactionExports/useTransactionExportsTable';

export const ProviderTransactionsTitle: React.FC = () => {
  const { providerTransactionTableFilters, handleClearProviderTransactionTableFilters } =
    useProviderTransactionsTable();
  const { openTransactionExportModal } = useTransactionExportsTable();
  const objectVals = Object.values(providerTransactionTableFilters);
  const disabled = objectVals.length === 0 || objectVals.every((val) => val === undefined);
  const defaultStartDate = providerTransactionTableFilters?.createdStartDate;
  const defaultEndDate = providerTransactionTableFilters?.createdEndDate;

  return (
    <AtLocator type="container" name="ProviderTransactionsListTitle">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ paddingBottom: 2 }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h3">Provider Transactions</Typography>
        </Stack>
        <Stack direction="row" gap={1}>
          {/* <Button
            size="large"
            variant="contained"
            onClick={() =>
              openTransactionExportModal(
                'PROVIDER_TRANSACTIONS',
                defaultStartDate,
                defaultEndDate,
                providerTransactionTableFilters
              )
            }
          >
            Export
          </Button> */}
          <AtLocator type="button" name="clearFilters">
            <Button
              size="large"
              variant="contained"
              disabled={disabled}
              onClick={handleClearProviderTransactionTableFilters}
            >
              Clear filters
            </Button>
          </AtLocator>
        </Stack>
      </Stack>
    </AtLocator>
  );
};
